import React from "react";
import { Modal, Spinner } from "react-bootstrap";

const BackdropFSLoader = ({ open }) => {
  return (
    <Modal
      show={open}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="backdrop-spinner"
      backdropClassName="backdrop-spinner-class"
      style={{ zIndex: 1056 }}
    >
      <Spinner animation="border" variant="primary" />
    </Modal>
  );
};

export default BackdropFSLoader;
